import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { CommonService } from "src/app/common.service";
import { Participation } from "participation-api";
import {
  GetTenderStatusDescription,
  GetTenderAttachmentTypeDersciption,
} from "../utils/tender-utils";
import { Province, Base64Document } from "profile-api";
import { ModalComponent } from "../modal/modal.component";
import { Router } from "@angular/router";

@Component({
  selector: "app-participation-detail",
  templateUrl: "./participation-detail.component.html",
  styleUrls: ["./participation-detail.component.css"],
})
export class ParticipationDetailComponent implements OnInit {
  @Input("tenderId") participationId: number;

  @ViewChild("metricCalculationModal") metricCalculationModal: ModalComponent;
  @ViewChild("publishConfirmationModal")
  publishConfirmationModal: ModalComponent;
  @ViewChild("confirmModal") confirmModal: ModalComponent;
  @ViewChild("publishConfirmationModalNotAccepted")
  publishConfirmationModalNotAccepted: ModalComponent;

  loading = false;
  error = "no_error";
  errorMessageClass: string = "alert";
  canChangeParticipation: boolean = true;
  participation: Participation = { tenderId: null };
  participationStatusDescr: string;
  constructionBox: string = "";
  renovationBox: string = "";
  systemBox: string = "";
  excavationBox: string = "";
  demolitionBox: string = "";
  provinceDescription: string;
  provinces: Array<Province>;
  errorMetricCalculationDoc: boolean = false;
  metricComputationMsg: string =
    "Per poter pubblicare la partecipazione è necessario caricare il computo metrico.";
  metricComputationMsgClass: string = "alert";
  discountedOffer: number;
  imputDiscountClass: string;

  constructor(private commonService: CommonService, private router: Router) {}

  ngOnInit(): void {
    this.commonService
      .getProvinces()
      .then((provinceList: Array<Province>) => {
        this.provinces = provinceList;
      })
      .catch((error) => {
        console.log("Impossibile caricare la lista delle province.");
      });

    this.commonService
      .getParticipationService()
      .tenderParticipationParticipationIdGet(this.participationId)
      .subscribe(
        (participation) => {
          this.loadParticipationInComponent(participation);
          console.log("partecipazione");
          console.log(participation);
        },
        (error) => {
          console.log(
            "Impossibile caricare la partecipazione " +
              this.participationId +
              "; error: " +
              error
          );
        }
      );
  }

  loadParticipationInComponent(participation: Participation) {
    this.participation = participation;
    this.participationStatusDescr = GetTenderStatusDescription(
      participation.participationStatus
    );

    switch (participation.categoryCode) {
      case Participation.CategoryCodeEnum.Construction:
        this.constructionBox = "ng-selected-category-box";
        break;
      case Participation.CategoryCodeEnum.Demolition:
        this.demolitionBox = "ng-selected-category-box";
        break;
      case Participation.CategoryCodeEnum.Excavation:
        this.excavationBox = "ng-selected-category-box";
        break;
      case Participation.CategoryCodeEnum.Renovation:
        this.renovationBox = "ng-selected-category-box";
        break;
      case Participation.CategoryCodeEnum.System:
        this.systemBox = "ng-selected-category-box";
        break;
      default:
        break;
    }

    if (this.provinces) {
      let participationProvince = this.provinces.filter(
        (province) => province.code === participation.provinceCode
      );
      this.provinceDescription = participationProvince[0].description;
    }

    this.canChangeParticipation =
      participation.participationStatus !== participation.tenderStatus;
  }

  openAttachment(attachment: Base64Document) {
    if (attachment.documentUrl) {
      window.open(attachment.documentUrl);
    }
  }

  deleteAttachment(attachment: Base64Document) {
    this.participation.attachments = this.participation.attachments.filter(
      (obj) => obj !== attachment
    );
  }

  uploadAttachment(
    attachmentType: string,
    event: { target: { files: any[] } }
  ) {
    let files = event.target.files;
    let file = files[0];
    if (files && file) {
      const reader = new FileReader();
      let attachment: Base64Document = {};
      attachment.documentType = attachmentType;
      attachment.fileName = file.name;
      attachment.mimeType = file.type;
      reader.onload = (readerEvt: { target: { result: any } }) => {
        return this.handleReaderLoaded(attachment, readerEvt);
      };
      reader.readAsBinaryString(file);
    }
  }

  handleReaderLoaded(
    attachment: Base64Document,
    readerEvt: { target: { result: any } }
  ) {
    let binaryString = readerEvt.target.result;
    let base64textString = btoa(binaryString);
    attachment.base64Content = base64textString;

    if (attachment.documentType) {
      this.participation.attachments.push(attachment);
    } else {
      //It's metric calculation
      this.participation.metricCalculationDoc = attachment;
      this.metricCalculationModal.close();
      this.saveParticipation();
      this.errorMetricCalculationDoc = true;
      this.metricComputationMsg = "Computo metrico caricato correttamente.";
      this.metricComputationMsgClass = "info";

      var that = this;
      setTimeout(function () {
        that.errorMetricCalculationDoc = false;
        this.metricComputationMsg =
          "Per poter pubblicare la partecipazione è necessario caricare il computo metrico.";
        this.metricComputationMsgClass = "alert";
      }, 4000);
    }
  }

  /*uploadAttachment(isMetricCalculation: boolean, event: { target: { files: any[]; }; }) {
    let files = event.target.files;
    let file = files[0];
    if (files && file) {
      const reader = new FileReader();
      let attachment: Base64Document = {};
      attachment.fileName = file.name;
      attachment.mimeType = file.type;
      reader.onload = (readerEvt: { target: { result: any; } }) => {
        return this.handleReaderLoaded(isMetricCalculation, attachment, readerEvt);
      };
      reader.readAsBinaryString(file);
    }
  }

  handleReaderLoaded(isMetricCalculation: boolean, attachment: Base64Document, readerEvt: { target: { result: any; } }) {
    let binaryString = readerEvt.target.result;
    let base64textString = btoa(binaryString);
    attachment.base64Content = base64textString;

    if (!isMetricCalculation) {
      this.participation.attachments.push(attachment);
    } else {
      this.participation.metricCalculationDoc = attachment;
      this.saveParticipation();
      this.metricCalculationModal.close();
      this.errorMetricCalculationDoc = false;
    }
  }*/

  saveParticipation() {
    this.errorMetricCalculationDoc = false;
    this.metricComputationMsg =
      "Per poter pubblicare la partecipazione è necessario caricare il computo metrico.";
    this.metricComputationMsgClass = "alert";
    this.loading = true;
    this.commonService
      .getParticipationService()
      .tenderParticipationParticipationIdPut(
        this.participation.participationId,
        this.participation
      )
      .subscribe(
        (participation) => {
          this.loadParticipationInComponent(participation);
          this.loading = false;

          this.error = "La partecipazione è stata salvata correttamente.";
          this.errorMessageClass = "info";

          var that = this;
          setTimeout(function () {
            that.error = "no_error";
            that.errorMessageClass = "alert";
          }, 4000);
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante il salvataggio della partecipazione.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  getDocumentTypeDescription(attachment: Base64Document) {
    return GetTenderAttachmentTypeDersciption(attachment);
  }

  getDownloadButtonStyle(attachment: Base64Document) {
    if (attachment && attachment.documentUrl) {
      return "";
    } else {
      return "-disabled";
    }
  }

  validatePublishData() {
    if (
      !this.participation.metricCalculationDoc ||
      !this.participation.metricCalculationDoc.documentUrl
    ) {
      this.errorMetricCalculationDoc = true;
      this.metricComputationMsg =
        "Per poter pubblicare la partecipazione è necessario caricare il computo metrico.";
      this.metricComputationMsgClass = "alert";
      return false;
    }
    return true;
  }

  publishTender() {
    this.loading = true;

    this.publishConfirmationModal.close();

    if (!this.validatePublishData()) {
      this.error = "I campi non sono compilati correttamente.";
      console.log("Invalid participation pubblish data.");
      this.loading = false;
      return;
    } else {
      this.error = "no_error";
    }

    this.commonService
      .getParticipationWorkflowService()
      .tenderParticipationParticipationIdPublishPut(
        this.participation.participationId,
        this.participation
      )
      .subscribe(
        (participation: Participation) => {
          this.loadParticipationInComponent(participation);
          this.loading = false;

          this.error = "Partecipazione pubblicata correttamente.";
          this.errorMessageClass = "info";

          var that = this;
          setTimeout(function () {
            that.error = "no_error";
            that.errorMessageClass = "alert";
          }, 4000);
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante la pubblicazione della partecipazione.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  goToParticipations() {
    this.router.navigate(["/areariservata"], {
      queryParams: { tabToLoad: "myParticipations" },
    });
    //window.open('/areariservata?tabToLoad=myParticipations','_self');
  }

  clearClass() {
    this.imputDiscountClass = "";
    this.error = "";
  }

  sendDiscount() {
    this.loading = true;

    this.confirmModal.close();

    if (this.participation.participationStatus === "ONGOING") {
      this.commonService
        .getParticipationWorkflowService()
        .tenderParticipationParticipationIdDiscountPut(
          this.participation.participationId,
          this.participation
        )
        .subscribe(
          (participation: Participation) => {
            this.loadParticipationInComponent(participation);
            this.loading = false;

            this.error = "Preventivo scontato inviato correttamente.";
            this.errorMessageClass = "info";

            var that = this;
            setTimeout(function () {
              that.error = "no_error";
              that.errorMessageClass = "alert";
            }, 4000);
          },
          (error) => {
            if (error.status === 400) {
              this.error = error.error.errors[0].text;
            } else {
              this.error =
                "Si è verificato un errore durante il salvataggio della partecipazione.";
            }
            this.loading = false;
            console.log(error);
          }
        );
    } else if (this.participation.participationStatus === "DISCOUNT") {
      this.commonService
        .getParticipationWorkflowService()
        .tenderParticipationParticipationIdDealPut(
          this.participation.participationId,
          this.participation
        )
        .subscribe(
          (participation: Participation) => {
            this.loadParticipationInComponent(participation);
            this.loading = false;

            this.error = "Preventivo scontato inviato correttamente.";
            this.errorMessageClass = "info";

            var that = this;
            setTimeout(function () {
              that.error = "no_error";
              that.errorMessageClass = "alert";
            }, 4000);
          },
          (error) => {
            if (error.status === 400) {
              this.error = error.error.errors[0].text;
            } else {
              this.error =
                "Si è verificato un errore durante il salvataggio della partecipazione.";
            }
            this.loading = false;
            console.log(error);
          }
        );
    } else {
      this.error = "Non è possibile inviare uno sconto in questo stato.";
    }
  }

  goToQuestionsAndAnswers() {
    this.router.navigate(["/areariservata"], {
      queryParams: {
        tabToLoad: "participationQuestionsAndAnswers",
        openedFrom: "participation",
        participationId: this.participation.participationId,
        tenderId: this.participation.tenderId,
        tenderTitle: this.participation.title,
        editable: this.isQAEditable(),
      },
    });
    // window.open('/areariservata?tabToLoad=questionsAndAnswers&openedFrom=participation&tenderId=' + this.participation.tenderId +
    //             '&tenderTitle=' + this.participation.title,'_self');
  }

  isQAEditable() {
    return (
      this.participation.tenderStatus !== "ACCEPTED" &&
      this.participation.tenderStatus !== "REFUSED" &&
      this.participation.tenderStatus !== "ABORTED"
    );
  }

  ManagePublishConfirmationModals() {
    if (this.participation.accepted == null) {
      this.publishConfirmationModalNotAccepted.open();
    } else if (this.participation.accepted) {
      this.publishConfirmationModal.open();
    }
  }
}
